import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AslibModalComponent, AslibModalService } from '@aslib/modal';
import { Subscription } from 'rxjs/Subscription';
import { ModalManagerHelper } from './../../shared/helpers/modal-manager-helper';

import { Ano, Mes, TipoReceita } from './shared/model/distribuicaoMensalMunicipio.model';
import { AslibLoadingService } from '@aslib/loading';
import { Messages } from './../../shared/helpers/mensages';
import { ShowFile } from '../../shared/helpers/show-file';
import { ExportTypes } from '../../shared/enum/TypeExportReportEnums';

import { DistribuicaoMensalMunicipioService } from './shared/service/distribuicaoMensalMunicipio.service';
import { DistribuicaoMensalMunicipioFiltro, DistribuicaoMensalMunicipioModelView } from './shared/model/distribuicaoMensalMunicipio.model';

@Component({
  selector: 'sarf-distribuicao-mensal-municipio.component',
  templateUrl: './distribuicao-mensal-municipio.component.html'
})

export class DistribuicaoMensalMunicipioComponent implements OnInit {
  subscription: Subscription;
  observerOnIniftFormulario: Subscription;
  showFile: ShowFile;
  aslibModal: AslibModalComponent;

  exibirGrid:boolean;
  listaAno: Ano[];
  listaMes: Mes[];
  listaTipoReceita: TipoReceita[];

  tipoReceitaSelected: TipoReceita;
  anoSelected: Ano;
  mesSelected: Mes;
  tipoRel: number;
  filtro: DistribuicaoMensalMunicipioFiltro;
  distribuicaoMensalMunicipioModelView: DistribuicaoMensalMunicipioModelView;
  
  @ViewChild(AslibModalComponent) modalMensagem: AslibModalComponent;
  

  constructor(
    private readonly distribuicaoMensalMunicipioService: DistribuicaoMensalMunicipioService,
    private readonly modalManagerHelper: ModalManagerHelper,
    private readonly _aslibLoadingService: AslibLoadingService,
    private readonly _aslibModalService: AslibModalService,
    private readonly _messages : Messages
  ) {
    modalManagerHelper.parent = this;
    this.showFile = new ShowFile();
    this.distribuicaoMensalMunicipioModelView = new DistribuicaoMensalMunicipioModelView();
    this.filtro =  new DistribuicaoMensalMunicipioFiltro();
    this.exibirGrid=false;
  }

  formDistribuicaoMensal = new FormGroup({
    Ano: new FormControl(undefined, Validators.required),
    Mes: new FormControl(null, Validators.required),
    TipoReceita: new FormControl()
  });

  ngOnInit() {
    this.exibirGrid =false;
    this.dadosOnInitFormulario(this.modalMensagem);
   
    this.listaMes =[
    {Descricao: 'Janeiro', IdMes: '1'},
    {Descricao: 'Fevereiro', IdMes: '2'},
    {Descricao: 'Março', IdMes: '3'},
    {Descricao: 'Abril', IdMes: '4'},
    {Descricao: 'Maio', IdMes: '5'},
    {Descricao: 'Junho', IdMes: '6'},
    {Descricao: 'Julho', IdMes: '7'},
    {Descricao: 'Agosto', IdMes: '8'},
    {Descricao: 'Setembro', IdMes: '9'},
    {Descricao: 'Outubro', IdMes: '10'},
    {Descricao: 'Novembro', IdMes: '11'},
    {Descricao: 'Dezembro', IdMes: '12'}];
  }

  dadosOnInitFormulario(modal: AslibModalComponent){

    this.observerOnIniftFormulario = this.distribuicaoMensalMunicipioService.dadosOnInitFormulario().subscribe(
      retornoRequest => {

        this.listaAno = retornoRequest.ListaAno;
        this.listaTipoReceita = retornoRequest.ListaTipoReceita;

        this.filtroConsulta();
        this.exibirGrid=false;
      
        if(retornoRequest.objetoMensagem &&  
          retornoRequest.objetoMensagem.Mensagem !== null &&  
          retornoRequest.objetoMensagem.Mensagem !== ''){
            this.modalManagerHelper.modalMensagem(modal, retornoRequest.objetoMensagem);
        }

      },
      () => this.observerOnIniftFormulario.unsubscribe()
    );
  }
  
  consultarDistribuicaoMensal(modal: AslibModalComponent) {
    this.filtroConsulta();

    this.observerOnIniftFormulario = this.distribuicaoMensalMunicipioService
    .consultarDistribuicaoMensalMunicipio(this.filtro).subscribe(
      retornoRequest => {
      
        this.distribuicaoMensalMunicipioModelView.ListaDistribuicaoMensalMunicipio = retornoRequest.ListaDistribuicaoMensalMunicipio;
           
        let c = this.distribuicaoMensalMunicipioModelView.ListaDistribuicaoMensalMunicipio.length;
        this.exibirGrid = c>0?true:false;

        if(retornoRequest.objetoMensagem &&  retornoRequest.objetoMensagem.Mensagem !== null &&  retornoRequest.objetoMensagem.Mensagem !== ''){
          this.modalManagerHelper.modalMensagem(modal, retornoRequest.objetoMensagem);
         }
       },
       () => this.observerOnIniftFormulario.unsubscribe()
     );
   }

   public filtroConsulta(){
    this.filtro.IdAno = this.anoSelected.IdAno;
    this.filtro.IdMes = this.mesSelected.IdMes;
    this.filtro.DescricaoMes = this.mesSelected.Descricao;
    this.filtro.IdTipoReceita =  this.tipoReceitaSelected.IdTipoReceita;
  }

  public onChangeTipoReceita(){
    console.log(this.formDistribuicaoMensal.value.Ano)
    console.log(this.formDistribuicaoMensal.value.Mes)
  }

    gerarRelatorio(tipoFile: number) {
      let tipoRel: ExportTypes;
      
      tipoRel = tipoFile==0?ExportTypes.PDF:ExportTypes.Excel_xls;
  
      this.filtroConsulta();
      this._aslibLoadingService.start();
      this.subscription = this.distribuicaoMensalMunicipioService
        .gerarRelatorioDistribuicaoMensal(this.filtro, tipoRel).subscribe(
          data => {
            this.showFile.Windows(data,tipoRel);
          },
          (error: any) => {
            this._aslibLoadingService.complete();
            new AslibModalComponent(this._aslibModalService).open({
              title: 'ERRO',
              text: this._messages.MN0011,
              type: 'erro'
            });
          },
          () => {
           this.unSubscribe();
          }
        );
      }

  unSubscribe() {
    this._aslibLoadingService.complete();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/consulta/distribuicao-mensal-aos-municipio/distribuicao-mensal-municipio.component.ts